// @ts-check

// import Axios from 'axios'

import { Constants } from "@/config";
import http from "../../../../axiosInstance";

/**
 * @type {import('vuex').ActionTree<neptune.payment.ICreditCardState, neptune.IRootState>}
 */
const actions = {
  async getPaymentMethodData({ commit, rootGetters }) {
    // const { UserId } = getters;
    try {
      const { data } = await http.get(
        //  `${Constants.SAVED_PAYMENTMETHODS_URL}`
        Constants.SAVED_PAYMENTMETHODS_URL.replace(
          "{{policyNo}}",
          rootGetters["policy/allData"].policyNo
        )
      );

      commit("SET_PROP", {
        path: "paymentMethodData",
        value: data.payload || ""
      });

      return data;
    } catch (error) {
      return Promise.reject(new Error(error));
    }
  },

  async createPaymentIntent(
    { commit },
    { existingPaymentMethodId, policyNo, cardType, country, payerName }
  ) {
    try {
      const data = await http.post(
        // '/api/v1/payments/intent',
        Constants.INTENT_URL,
        {
          policyNo,
          existingPaymentMethod: existingPaymentMethodId,
          cardType,
          country,
          payerName
        }
      );

      if (!data) {
        return Promise.reject(
          Error(
            `${Constants.INTENT_URL} did not return any valid response. Please try a different credit card `
          )
        );
      }

      commit("SET_PROP", {
        path: "paymentIntentToken",
        value: data?.data?.payload?.clientSecret
      });

      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async updatePaymentIntent({ commit }, { existingPaymentMethodId, policyNo, cardType, country }) {
    try {
      const data = await http.put(
        // '/api/v1/payments/intent',
        Constants.INTENT_URL,
        {
          existingPaymentMethod: existingPaymentMethodId,
          policyNo: policyNo,
          cardType,
          country
        }
      );

      if (!data) {
        return Promise.reject(
          Error(
            `${Constants.INTENT_URL} did not return any valid response. Please try a different credit card `
          )
        );
      }

      commit("SET_PROP", {
        path: "paymentIntentToken",
        value: data?.data?.payload?.clientSecret
      });

      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * @deprecated Use confirmCardPayment Instead
   * https://stripe.com/docs/stripe-js/reference#stripe-handle-card-payment
   * @param {import('vuex').ActionContext<neptune.payment.ICreditCardState, neptune.IRootState>} param0
   * @param {neptune.payment.IStripePaymentParams} param1
   */
  // @ts-ignore
  async handleStripeCardPayment({ commit, state }, { stripe, cardNumber }) {
    const { paymentIntentToken } = state;

    const res = await stripe.handleCardPayment(paymentIntentToken, cardNumber, {});
    if (res.error) {
      return Promise.reject(res.error?.message ?? res.error);
    }

    commit("SET_PROP", {
      path: "stripePaymentData",
      value: res.paymentIntent || res
    });

    return res;
  },

  // todo: test to see if the payment was successful before calling this
  async savePaymentData({ state }, { policyNo, email, payerName, remember }) {
    // const email = rootState.currentQuote?.quote?.application?.email
    const intentId = state.stripePaymentData.id;
    const amount_received = state.stripePaymentData.amount;
    const paymentMethodId = state.stripePaymentData.payment_method;
    const intentObject = state.stripePaymentData;

    /** @type {neptune.payment.ISavePaymentParams} */
    const payload = {
      policyNo: policyNo,
      // @ts-ignore
      amount: amount_received,
      intentId: intentId,
      paymentMethodId: paymentMethodId,
      email: email,
      payerName: payerName,
      saveForReuse: remember,
      responseData: intentObject
    };

    try {
      const res = await http.post(
        Constants.PAY_CARD_URL, // '/api/v1/payments/card',
        payload
      );

      return res.data;
    } catch (error) {
      return Promise.reject(new Error(error));
    }
  }
};

export default actions;
